import React, { useState, useEffect } from 'react';

import './styles.css';


import { Dots } from "react-activity";

import { FaBell } from 'react-icons/fa';
import studentsServices from '../../../../services/academy/studentsServices';
import Popup from '../../../../components/Popup';
import Input from '../../../../components/Input';

function PopupNewEmail(props) {
    const [tittle, setTittle] = useState("");
    const [content, setContent] = useState("");
    const [uploading, setUploading] = useState(false);




    async function createNotification() {
        if (tittle && content) {
            setUploading(true);
            const ids = Object.keys(props.ids).map(key=> Number(key))
            const response = await studentsServices.postStudentsEmail(tittle, content, ids);
            setUploading(false);
            if (response.status === 204) {
                    alert("Email enviado com sucesso!");
                    props.onSend();
                    props.setVisibility(false);
                    setTittle("");
                    setContent("");
            } else
                alert("Erro ao enviar email, tente novamente!");
        } else
            alert("Preencha os dados obrigatórios*");
    };

    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            icon={<FaBell />}
            tittle='Email'

        >
            <form action="" className='student-new-notification-form'>
                <Input
                    label='Título*'
                    placeholder="Insira aqui o título"
                    id='student-new-notification-tittle'
                    onChange={(event) => setTittle(event.target.value)}
                    value={tittle}
                />
                <Input
                    label='Conteúdo*'
                    placeholder="Insira aqui o conteúdo"
                    type='textarea'
                    rows={3}
                    id='student-new-notification-content'
                    onChange={(event) => setContent(event.target.value)}
                    value={content}
                />

                <button
                    type='button'
                    onClick={() => uploading ? alert("Um envio já está em andamento.") : createNotification()}
                >
                    {
                        uploading ?
                            <Dots />
                            : "Enviar"
                    }
                </button>
            </form>
        </Popup>
    )
}

export default PopupNewEmail;